import { render, staticRenderFns } from "./admin-agent.vue?vue&type=template&id=714e2421&scoped=true&"
import script from "./admin-agent.vue?vue&type=script&lang=js&"
export * from "./admin-agent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "714e2421",
  null
  
)

export default component.exports